import Axios from "@app/api/axios";
import { COURTS } from "@utils/constant";
const deleteCourtsService = (id) => {
  return Axios.delete(`${COURTS}/${id}`)
};
export default deleteCourtsService;